import { Injectable } from '@angular/core';
import { ApiService } from '../abstract/api-service.abstract';
import { Observable } from 'rxjs';
import { RegulatoryPraModel } from '../models/regulatory-pra.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RegulatoryPraService extends ApiService {
  getItemById(id: string): Observable<RegulatoryPraModel> {
    const url = `${this.apiFrontUrl}/reg-plan-item/${id}?date=${this.cacheUid()}`;

    return this.http.get<any>(url).pipe(
      map((data) => {
        if (data) {
          return RegulatoryPraModel.fromJson(data);
        }
        return data;
      }),
    );
  }

  list(
    params: any = {},
  ): Observable<{ data: RegulatoryPraModel[]; count: number }> {
    const url = `${this.apiFrontUrl}/reg-plan-item/list?date=${this.cacheUid()}`;
    return this.http.get<any>(url, { params }).pipe(
      map((data) => {
        return {
          data: Array.isArray(data.data)
            ? data.data.map((item: any) => RegulatoryPraModel.fromJson(item))
            : [],
          count: data.count ?? 0,
        };
      }),
    );
  }

  getFilterOptions(): Observable<{
    regActTypeTitles: string[];
    regDomains: string[];
    actTerritoryTypeTitles: string[];
    authorizedUnits: string[];
  }> {
    const url = `${this.apiFrontUrl}/reg-plan-item/selects-data?date=${this.cacheUid()}`;
    return this.http.get<any>(url);
  }
}
